/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link, Text, View } from '@react-pdf/renderer';
import styles from '../pro-report-pdf-styles';

function ClubContact() {
  return (
    <View wrap={false} style={styles.table}>
      <Text style={styles.tableHeaderFullWidth}>Club contact</Text>
      <Text style={styles.tableCellFullWidth}>
        If you require any further assistance, please liaise with your usual{' '}
        <Link src="https://north-standard.com/our-people" style={styles.link}>
          club contact
        </Link>
        .
      </Text>
    </View>
  );
}

export default ClubContact;
